import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Icon, Dropdown } from 'semantic-ui-react';
import MediaQuery from 'react-responsive';
import moment from 'moment-timezone';
import { breakpoints } from 'helpers/breakpoints';
import { ascendingSorting } from 'helpers/common';
import styles from './index-module.css';
import TimeslotModal from '../../timeslot-modal/TimeslotModal';
import { SELECT_ALL_LISTINGS, SPECIFIC } from '../../consts';
import { messages } from '../locale';
import EditIcon from '../../../../assets/add-ons/edit.svg';
import WarningIcon from '../../../../assets/add-ons/warning.svg';

const TimeslotRow = injectIntl((props) => {
  const { eventData, intl, timeslotList, selectedWeekDays, setSelectedWeekDays,
    startTime, setStartTime, endTime, setEndTime, startDate, setStartDate, endDate, setEndDate,
    setSelectedListing, handleTimeslotsSelected, showTimeslotModal, setShowTimeslotModal,
    setTimeslotList, setEditIndex, setTimeslotRates, addOnAvailabilityRule, selectedTicketTypes,
    timeslotRates, availabilityList, setAvailabilityList, formatTimeString,
    slots, setSlots, isRuleMatching
  } = props;
  const [selectedTimeslot, setSelectedTimeslot] = useState([]);
  const [ongoingEnable, setOngoingEnable] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [firstEventDate, setFirstEventDate] = useState(null);
  const [exclusiveWeekday, setExclusiveWeekday] = useState([]);

  const weekDays = [
    { text: intl.formatMessage(messages.mondayWeekday), value: 'MONDAY', index: 1 },
    { text: intl.formatMessage(messages.tuesdayWeekday), value: 'TUESDAY', index: 2 },
    { text: intl.formatMessage(messages.wednesdayWeekday), value: 'WEDNESDAY', index: 3 },
    { text: intl.formatMessage(messages.thursdayWeekday), value: 'THURSDAY', index: 4 },
    { text: intl.formatMessage(messages.fridayWeekday), value: 'FRIDAY', index: 5 },
    { text: intl.formatMessage(messages.saturdayWeekday), value: 'SATURDAY', index: 6 },
    { text: intl.formatMessage(messages.sundayWeekday), value: 'SUNDAY', index: 0 },
  ];

  useEffect(() => {
    const eventSelections = [];
    eventData.forEach(value => {
        const findRuleIndex = addOnAvailabilityRule.findIndex(ruleData => ruleData.listingId === value.id);
        const timeslotIndex = timeslotList.findIndex(slotData => slotData.listingId === value.id);
        if (findRuleIndex !== -1 || timeslotIndex !== -1) {
          eventSelections.push({id: value.id, timeslot: SPECIFIC, showTimeslot: true});
        } else {
          eventSelections.push({id: value.id, timeslot: SELECT_ALL_LISTINGS, showTimeslot: false});
        }
      })
    setSelectedTimeslot(eventSelections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData.length]);

  useEffect(() => {
    if (startDate && endDate) {
      checkExclusiveRule(slots, timeslotRates);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, slots, timeslotRates]);

  useEffect(() => {
    addOnAvailabilityRule.forEach(value => {
      const eventIndex = eventData.findIndex(event => value.listingId === event.id);
      if (eventIndex !== -1) {
        value.rates = eventData[eventIndex].rates.nodes;
        value.timeSlots = eventData[eventIndex].timeSlots.nodes;
      }
      else {
        value.rates = [];
        value.timeSlots = [];
      }
      if (selectedTicketTypes && Object.keys(selectedTicketTypes).length > 0
          && value.rates.length > 0
          && selectedTicketTypes[value.listingId]
          && Array.from((selectedTicketTypes[value.listingId])).length > 0) {
        const ratesData = [];
        value.rates.forEach(rate => {
          if (Array.from((selectedTicketTypes[value.listingId])).indexOf(rate.id) > -1) {
            ratesData.push(rate);
          }
        });
        value.rates = ratesData;
      }
      const startHour = formatTimeString(value.startHour);
      const startMinute = formatTimeString(value.startMinute);
      const endHour = formatTimeString(value.endHour);
      const endMinute = formatTimeString(value.endMinute);
      const startTimeRange = startHour && startMinute
        && moment(`${startHour}${startMinute}`, 'HHmm').format('h:mm A') || null;
      const endTimeRange = endHour && endMinute
        && moment(`${endHour}${endMinute}`, 'HHmm').format('h:mm A') || null;
      value.endDate = value.endDate ? moment(value.endDate) : null;
      value.startDate = moment(value.startDate);
      value.startTime= startTimeRange;
      value.endTime= endTimeRange;
      value.addOnAvailabilityRuleId = value.id;
      if (!Array.isArray(value.weekdays)) {
        if (value?.weekdays !== null) {
          value.weekdays= value.weekdays.split(",").map(Number);
          ascendingSorting(value.weekdays);
        } else {
          value.weekdays= [];
        }
      }
      value.showWarning = isRuleMatching(startTimeRange,
        value.endDate, value.endTime, value.timeSlots, value.rates, value.startDate, value.weekdays);
    });
    if (availabilityList.length === 0) {
      setTimeslotList([...timeslotList, ...addOnAvailabilityRule]);
      setAvailabilityList([...timeslotList, ...addOnAvailabilityRule]);
    }
    setSlots(eventData[0].timeSlots.nodes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addOnAvailabilityRule.length, selectedTicketTypes]);

  const getWeekdays = (weekStartDate, weekEndDate) => {
    return Array.from({ length: moment(weekEndDate).diff(weekStartDate, 'days') + 1 },
    (_, i) => moment(weekStartDate).add(i, 'days').day());
  }

  const checkExclusiveRule = (timeslotRule, exclusiveRates) => {
    let exclusionRule = [];
    exclusiveRates.forEach(rate => {
      rate.exclusionRules.length > 0 && rate.exclusionRules.forEach(rule => {
        if (rule?.type === "wday") {
          exclusionRule = [...exclusionRule, ...rule.value];
        }
      });
    });

    timeslotRule.forEach(rule => {
      let slotStartDay = moment(rule.startAt).isoWeekday();
      const slotEndDay = moment(rule.endAt).isoWeekday();
      if (moment(rule.startAt).isAfter(moment())
        || moment(rule.startAt, 'YYYY-MM-DD').isSame(moment().startOf('day'))) {
        if (slotStartDay !== slotEndDay) {
          exclusionRule = [...exclusionRule, ...getWeekdays(rule.startAt, rule.endAt)];
        } else {
          // isoWeekday function is giving 7 for sunday but for our data
          // we are maintaining sunday as 0 in database
          if (slotStartDay === 7) {
            slotStartDay = 0;
          }
          exclusionRule.push(slotStartDay);
        }
      }
    });
    const getStartEndDateWeekday = getWeekdays(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
    if (exclusionRule.length > 0) {
      const exclusiveWeekdayFilter = getStartEndDateWeekday.filter((day) => {
        return new Set(exclusionRule).has(day);
      });
      setExclusiveWeekday(exclusiveWeekdayFilter);
    }
    else {
      setExclusiveWeekday(getStartEndDateWeekday);
    }
  }

  const onTimeslotSelection = (listingId, listingSlots, rates, firstTimeSlot) => {
    setStartDate(undefined);
    setEndDate(undefined);
    setStartTime(null);
    setEndTime(null);
    setSelectedWeekDays([]);
    setEditIndex(null);
    setShowTimeslotModal(true);
    setSelectedListing(listingId);
    setSlots(listingSlots.nodes);
    setFirstEventDate(firstTimeSlot);

    if (selectedTicketTypes
      && Object.keys(selectedTicketTypes).length > 0
      && selectedTicketTypes[listingId] && Array.from(selectedTicketTypes[listingId]).length > 0
      && rates.length > 0) {
      const ratesData = [];
      rates.forEach(rate => {
        if (Array.from((selectedTicketTypes[listingId])).indexOf(rate.id) > -1) {
          ratesData.push(rate);
        }
      });
      setTimeslotRates(ratesData);
    } else {
      setTimeslotRates(rates);
    }
    setOngoingEnable(false);
  }

  const handleSpecificTimeslot = (listingDataId, key) => {
    selectedTimeslot[key] = {id: listingDataId, timeslot: SPECIFIC, showTimeslot: true}
    const newList = [];
    availabilityList.forEach(dataObj => dataObj.listingId === listingDataId && newList.push(dataObj));
    const isListingIdExist = timeslotList.some(listing => listing.listingId === listingDataId);
    if (!isListingIdExist) {
      setTimeslotList([...timeslotList, ...newList]);
    } else {
      setTimeslotList([...timeslotList]);
    }
    setSelectedTimeslot([...selectedTimeslot]);
  }

  const handleAllTimeslot = (listingDataId, key) => {
    selectedTimeslot[key] = {id: listingDataId, timeslot: SELECT_ALL_LISTINGS, showTimeslot: false}
    setSelectedTimeslot([...selectedTimeslot]);
    const newList = timeslotList.filter(timeslotObj => timeslotObj.listingId !== listingDataId);
    setTimeslotList(newList);
  }

  const handleDeleteOption = (index) => {
    const newList = [...timeslotList.slice(0, index), ...timeslotList.slice(index + 1)];
    setTimeslotList(newList);
  }

  const handleEditOption = (index, slotsRate, listingSlots) => {
    if (timeslotList[index].endDate === null) {
      setOngoingEnable(true);
    }
    setStartDate(timeslotList[index].startDate);
    setEndDate(timeslotList[index].endDate);
    setStartTime(timeslotList[index].startTime);
    setEndTime(timeslotList[index].endTime);
    setSelectedWeekDays(timeslotList[index].weekdays);
    setEditIndex(index);
    setSelectedListing(timeslotList[index].listingId);
    setShowTimeslotModal(true);
    if (Object.keys(selectedTicketTypes).length > 0 && slotsRate.length > 0) {
      const ratesData = [];
      slotsRate.forEach(rate => {
        if (Array.from(selectedTicketTypes[timeslotList[index].listingId]).indexOf(rate.id) !== -1) {
          ratesData.push(rate);
        }
      });
      setTimeslotRates(ratesData);
    } else {
      setTimeslotRates(slotsRate);
    }
    setIsActive(false);
    setSlots(listingSlots.nodes);
  }

  const renderTimeslotList = (listingId, listingSlots, isDesktop) => {
    return (timeslotList.length && timeslotList.map((list, index) => {
      const listRate = (list.rates === undefined) ? timeslotRates : list.rates;
      let warningMsg = '';
      const today = moment().startOf('day');
      if (list.endDate && list.endDate.isBefore(today, 'day')) {
        warningMsg = intl.formatMessage(messages.timeslotWarningPast);
      } else {
        warningMsg = intl.formatMessage(messages.timeslotWarning);
      }
      if (list.listingId === listingId) {
        const endDateStr = list.endDate ? list.endDate.format('MMM D, YYYY') : 'Ongoing';
        const startYear = Number(moment(list.startDate).format('YYYY'));
        const endYear = Number(moment(list.endDate).format('YYYY'));
        const startDateStr = (startYear === endYear)
          ? list.startDate.format('MMM D')
          : list.startDate.format('MMM D, YYYY');
        return  <>
          <div className={styles.timeslotList}>
            <div>
              {list.startDate ? startDateStr : ''} - {endDateStr}
            </div>
            <div>{(list.weekdays.length > 0 && list.weekdays.length !== 7) ? list.weekdays.map((day, key) => {
              return <>
                {weekDays[weekDays.findIndex(week => week.index === day)].text.substr(0,2)}
                {(key < list.weekdays.length - 1) ? ', ' : ''}
              </>})
                :  intl.formatMessage(messages.allDays)
              }
            </div>
            <div>{list.startTime
              ? `${list.startTime} - ${list.endTime}`
              : intl.formatMessage(messages.allTimeslots)}
            </div>
            {isDesktop && <div className={`${styles.column} ${styles.actions}`}>
              <div className={styles.editIcon}>
                <button 
                  className="ui fluid icon button"
                  onClick={() => handleEditOption(index, listRate, listingSlots)}
                >
                  <EditIcon />
                </button>
              </div>
              <div className={styles.trashDeleteIcon}>
                <button className="ui fluid icon button"
                  onClick={() => handleDeleteOption(index)}>
                  <i aria-hidden="true" className="grey large icon universe-delete"/>
                </button>
              </div>
            </div>}
          </div>
          <div className={styles.warningMessage}>
            {list.showWarning && <div
                className={styles.warningIcon}
              >
                <WarningIcon />
                {warningMsg}
              </div>
            }
          </div>
          {!isDesktop && <div className={styles.actions}>
            <button
              className={styles.editButton}
              onClick={() => handleEditOption(index, listRate, listingSlots)}
            >
              {intl.formatMessage(messages.editButton)}
            </button>
            <button
              className={styles.deleteButton}
              onClick={() => handleDeleteOption(index)}
            >
              {intl.formatMessage(messages.deleteButton)}
            </button>
          </div>}
          <div className={styles.line} />
        </>
      }
      return null;
    }));
  }

  const renderDesktopRow = () => {
    return <div className={styles.mainContainer}>
      {(eventData.length > 0) && (selectedTimeslot.length > 0)
        && eventData.map((listingData, key) => {
          const { id, imageUrl, title, timeSlots, rates, firstTimeSlot } = listingData;
          return <>
            <div className={styles.row}>
              <div className={styles.eventName}>
                <div className={styles.imageTitleWrapper}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={imageUrl}
                      className={styles.image}
                      alt="listing_img"
                    />
                  </div>
                  <div className={styles.title}>{title}</div>
                </div>
              </div>
              <div className={styles.availability}>
                <div className={styles.buttonBar}>
                  <div
                    className={`${styles.button}
                      ${selectedTimeslot[key]?.timeslot === SELECT_ALL_LISTINGS && styles.active}`}
                    onClick={() => handleAllTimeslot(id, key)}
                    role="button"
                    tabIndex={0}
                  >
                    {intl.formatMessage(messages.allTimeslots)}
                  </div>
                  <div className={styles.buttonDivider} />
                    <div
                      className={`${styles.button} ${selectedTimeslot[key]?.timeslot === SPECIFIC && styles.active}`}
                      onClick={() => handleSpecificTimeslot(id, key)}
                      role="button"
                      tabIndex={0}
                    >
                      {intl.formatMessage(messages.specificTimeslots)}
                    </div>
                </div>
              </div>
              {selectedTimeslot[key]?.showTimeslot && <div className={styles.addTimeslotAction}>
                  <div>
                    <button className={styles.addMore}
                      onClick={() =>
                        onTimeslotSelection(id, timeSlots, rates.nodes, firstTimeSlot)}
                    >
                      <Icon className="universe-plus" />
                      {intl.formatMessage(messages.addTimeslots)}
                    </button>
                  </div>
                </div>
              }
            </div>
            <div className={styles.line} />
            {selectedTimeslot[key]?.showTimeslot &&
              (timeslotList.find(list => list.listingId === id)
                ? renderTimeslotList(id, timeSlots, true)
                : <>
                    <div className={styles.specifiedTimeslot}>
                      {intl.formatMessage(messages.noTimeslotSpecified)}
                    </div>
                    <div className={styles.line} />
                  </>
              )
            }
      </>})
    }
  </div>
}

  const renderMobileRow = () => {
    const eventSelectorList = {
      SELECT_ALL_LISTINGS: {
        value: SELECT_ALL_LISTINGS,
        text: intl.formatMessage(messages.allTimeslots),
      },
      SELECT_SOME_LISTINGS: {
        value: SPECIFIC,
        text: intl.formatMessage(messages.specificTimeslots),
      }
    };

    return (
      <div className={styles.mainContainer}>
        {(eventData.length > 0) && (selectedTimeslot.length > 0)
          && eventData.map((listingData, key) => {
            const { id, imageUrl, title, timeSlots, rates, firstTimeSlot } = listingData;
            return <>
              <div className={styles.mobileRow}>
                <div className={styles.checkBoxAndImageWrapper}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={imageUrl}
                      className={styles.image}
                      alt="listing_img"
                    />
                  </div>
                  <div className={styles.title}>
                    {title}
                  </div>
                </div>
                <div className={styles.selectorlist}>
                  <Dropdown
                    onChange={(_, { value }) => {
                      if ( value === SELECT_ALL_LISTINGS) {
                        selectedTimeslot[key] = {id, timeslot: value, showTimeslot: false}
                      } else {
                        selectedTimeslot[key] = {id, timeslot: value, showTimeslot: true}
                      }
                      setSelectedTimeslot([...selectedTimeslot]);
                    }}
                    floating
                    labeled
                    trigger={<div><Icon color="grey" className='universe-date'/>
                      {selectedTimeslot[key]?.timeslot === SELECT_ALL_LISTINGS
                        ? intl.formatMessage(messages.allTimeslots)
                        : intl.formatMessage(messages.specificTimeslots)}
                      </div>}
                    selection
                    options={Object.values(eventSelectorList)}
                    value= {selectedTimeslot[key]?.timeslot}
                    className={styles.selector}
                  />
                </div>
                {selectedTimeslot[key]?.showTimeslot && <div className={styles.addTimeslotAction}>
                <button className={styles.addMore}
                     onClick={() =>
                      onTimeslotSelection(id, timeSlots, rates.nodes, firstTimeSlot)}
                  >
                    <Icon className="universe-plus" />
                    {intl.formatMessage(messages.addTimeslots)}
                  </button>
                </div>}
                <div className={styles.line} />
                {selectedTimeslot[key]?.showTimeslot &&
                  (timeslotList.find(list => list.listingId === id)
                    ? renderTimeslotList(id, timeSlots, false)
                    : <>
                        <div className={styles.specifiedTimeslot}>
                          {intl.formatMessage(messages.noTimeslotSpecified)}
                        </div>
                        <div className={styles.line} />
                      </>)
                }
              </div>
            </>
          })
        }
      </div>
    );
  }

  return (
    <div>
      <MediaQuery maxWidth={breakpoints.largestMobile}>
        {renderMobileRow()}
      </MediaQuery>
      <MediaQuery minWidth={breakpoints.largestMobile + 1}>
        {renderDesktopRow()}
      </MediaQuery>
      {showTimeslotModal && <TimeslotModal
        intl={props.intl}
        isOpen={showTimeslotModal}
        handleTimeslotsSelected={handleTimeslotsSelected}
        selectedWeekDays={selectedWeekDays}
        setSelectedWeekDays={setSelectedWeekDays}
        startTime={startTime}
        setStartTime={setStartTime}
        endTime={endTime}
        setEndTime={setEndTime}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        setShowTimeslotModal={setShowTimeslotModal}
        weekDays={weekDays}
        slots={slots}
        ongoingEnable={ongoingEnable}
        setOngoingEnable={setOngoingEnable}
        isActive={isActive}
        setIsActive={setIsActive}
        firstEventDate={firstEventDate}
        exclusiveWeekday={exclusiveWeekday}
      />}
    </div>)
});

export default TimeslotRow;
